module.exports = __webpack_public_path__ + "static/img/5bg_10.92c83ff.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/5bg_10.png
// module id = 714
// module chunks = 1